<script>
import { dispatch } from 'vuex-pathify';

export default {
    props: {
        before: {
            type: Number,
            default: null,
        },
    },
    methods: {
        showAddSectionModal() {
            dispatch('document/setSection', {
                before: this.before,
            });
            dispatch('document/setShowSectionModal', true);
        },
    },
};
</script>

<template>
    <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="line" />
        <b-button
            class="mx-3"
            variant="outline-primary"
            size="xs"
            @click="showAddSectionModal(before)"
        >
            <i class="fa fa-fw fa-plus" /> Add section
        </b-button>
        <div class="line" />
    </div>

</template>

<style scoped>
.line {
    flex-grow: 1;
    height: 1px;
    background-color: #e9ecef;
}
</style>

